/**
 * Roles Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
 import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    role:'',
    roles: [],
    permissions: [],
    userRoles: [],
    customUserRoles: [],
    features: [],
    users: [],
    user: {}
};

// Getters
const getters = {
    users: state => {
        return state.users
    },
    user: state => {
        return state.user
    },
    roles: state => {
        return state.roles
    },
    features: state => {
        return state.features
    },
    permissions:state => {
        return state.permissions
    },
    role:state=>{
      return state.role
    },
    userRoles: state => {
        return state.userRoles
    },
    customUserRoles: state => {
        return state.customUserRoles
    },
    hasMedecinControleRole(){
       let i = state.customUserRoles.findIndex(role=>role.name === "Medecin controle");
       return i >= 0;
    },
    hasPatientRole(){
        let i = state.customUserRoles.findIndex(role=>role.name == "Patient");
        return i >= 0;
    },
    hasPraticienRole(){
        let i = state.customUserRoles.findIndex(role=>role.name === "Praticien");
        return i >= 0;
    },
    hasSouscripteurRole(){
        let i = state.customUserRoles.findIndex(role=>role.name === "Souscripteur");
        return i >= 0;
    },
    hasGestionnaireRole(){
        let i = state.customUserRoles.findIndex(role=>role.name === "Gestionnaire");
        return i >= 0;
    },
    hasAdminRole(){
        let i = state.customUserRoles.findIndex(role=>role.name === "Admin");
        return i >= 0;
    },

    isComptable(){
        let comptable = (JSON.parse(localStorage.getItem('user'))).isEtablissement;
        return comptable;
    },
    hasAssistante(){
        let i = state.customUserRoles.findIndex(role=>role.name === "Assistante");
        return i >= 0;
    },
};

// Actions
const actions = {
    async permissions(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
 
            //  router.push({ name: 'assistant', params: { assistant: response.data.assistante.slug } });
         }
 
         function errorCallback(error) {
        }
        
        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Role.Create.url;
        console.log(payload.args);
        await Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'application/json',
                }
            }
        ).then(successCallback).catch(errorCallback);
         
       
    },

    async assignPermissionToUser(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
 
            //  router.push({ name: 'assistant', params: { assistant: response.data.assistante.slug } });
         }
 
         function errorCallback(error) {
        }
        
        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Permissions.assignUserPermissions.url;
        console.log(payload.args);
        await Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'application/json',
                }
            }
        ).then(successCallback).catch(errorCallback);
         
       
    },

    async assignFeatures(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
 
            //  router.push({ name: 'assistant', params: { assistant: response.data.assistante.slug } });
         }
 
         function errorCallback(error) {
        }
        
        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Features.Create.url;
        console.log(payload.args);
        await Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'application/json',
                }
            }
        ).then(successCallback).catch(errorCallback);
         
       
    },

    getUsersWithRoles(context, payload) {
        function successCallback(response) {
            context.commit('getUsersWithRolesHandler', { users: response.data.users });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Users.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    // user

    // getOneUser(context, payload) {
    //     function successCallback(response) {
    //         context.commit('getOneUserWithRolesHandler', { user: response.data });
    //     }

    //     function errorCallback(error) {
    //         Vue.notify({
    //             type: 'error',
    //             text: payload.errorMessages.error
    //         });
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.Users.One, localToken, successCallback, errorCallback, payload.errorMessages);
    // },
    getOneUser(context, payload) {
        function successCallback(response) {
            context.commit('getOneUserWithRolesHandler', { user: response.data.user });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, {"method" : "GET", "url" : "/one-user/"+payload.args}, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getRoles(context, payload) {
        function successCallback(response) {
            context.commit('getRolesHandler', { roles: response.data.roles });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Role.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getFeatures(context, payload) {
        function successCallback(response) {
            context.commit('getFeaturesHandler', { features: response.data.features });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Features.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPermissions(context, payload) {
        function successCallback(response) {
            context.commit('getPermissionsHandler', { permissions: response.data.permissions });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Permissions.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPermissionsByGroup(context, payload) {
        function successCallback(response) {
            context.commit('getPermissionsHandler', { permissions: response.data.permissions });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Permissions.Group, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getRole(context,payload){
        function successCallback(response) {
            context.commit('getRoleHandler', { role: response.data.role });
        }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Role.One, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCustomUserRoles(context,payload){
        context.commit('getCustomUserRolesHandler', { user: localStorage.getItem('user') });
    },

    getUserRoles(context, payload) {
        function successCallback(response) {
            context.commit('getUserRolesHandler', { roles: response.data.roles });
        }

        function errorCallback(error) {
            console.log("Error:", error);
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.User.Roles, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createRole(context, payload) {
        function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
         }

        function errorCallback(error) {
            Vue.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Role.CreateRole, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deleteRole(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Role.DeleteRole, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

const mutations = {
    getUsersWithRolesHandler(state, { users }) {
        // Update roles state
        state.users = users;
    },
    getOneUserWithRolesHandler(state, { user }) {
        // Update roles state
        state.user = user;
    },
    getRolesHandler(state, { roles }) {
        // Update roles state
        state.roles = roles;
    },
    getFeaturesHandler(state, { features }) {
        // Update roles state
        state.features = features;
    },

    getPermissionsHandler(state, { permissions }) {
        // Update roles state
        state.permissions = permissions;
    },

    getRoleHandler(state, { role }) {
        // Update roles state
        state.role = role;
    },

    getUserRolesHandler(state, { roles }) {
        // Update userRoles state
        state.userRoles = roles;
    },

    getCustomUserRolesHandler(state, { user }) {
        // Update userRoles state
        state.customUserRoles = (JSON.parse(user)).roles;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}